import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import MotorcycleIcon from '@mui/icons-material/TwoWheeler';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import SwapVerticalCircleIcon from '@mui/icons-material/SwapVerticalCircle';
import MapIcon from '@mui/icons-material/Map';
import AssignmentIcon from '@mui/icons-material/Assignment';

const iconsMap: any = {
  DashboardTwoToneIcon,
  LocationCityIcon,
  MotorcycleIcon,
  SwapVerticalCircleIcon,
  MapIcon,
  AssignmentIcon
};

export default [
  {
    label: 'Área de funcionário',
    content: JSON.parse(
      `[
        {
          "label": "Dashboards",
          "icon": "DashboardTwoToneIcon",
          "to": "/dashboard"
        },
        {
          "label": "Gestor de Chamadas",
          "icon": "SwapVerticalCircleIcon",
          "to": "/deliveries"
        },
        {
          "label": "Relatórios",
          "icon": "AssignmentIcon",
          "content": [
            {
              "label": "Relatório de entregas",
              "icon": "AssignmentIcon",
              "description": "",
              "to": "/deliveries-report"
            }
          ]
        },
        {
          "label": "Mapa",
          "icon": "MapIcon",
          "to": "/map"
        },
        {
          "label": "Clientes",
          "icon": "LocationCityIcon",
          "to": "/companies"
        },
        {
          "label": "Condutores",
          "icon": "MotorcycleIcon",
          "to": "/drivers"
        }
      ]`,
      (key, value) => {
        if (key === 'icon') {
          return iconsMap[value];
        }
        return value;
      }
    )
  }
];
